 
import React, {useEffect} from "react";
import { useTranslation } from 'react-i18next';
import "./../../../styles/HeaderComponent.scss";
import LinkComponent from './LinkComponent';
import {useDispatch} from "react-redux";
import {onChangeLanguage, onChangeLoading} from "../../redux/actions/ActionApp";
import jwt_decode from "jwt-decode";
import {LoginService} from "../services/LoginService";

// Language function 
// Provides language selector
export default function Language() {
    const { i18n, t } = useTranslation();
    const dispatch = useDispatch();
    const loginService = LoginService();
    useEffect(() => {
        if (window.location.pathname === '/') {
            const lg = localStorage.getItem('translationMKT') === null ? (navigator.language.includes('en') ?  'en' : 'es') : localStorage.getItem('translationMKT');
            reloadLanguage(lg);
        }
    }, []);


    const reloadLanguage = (lg) => {
        i18n.changeLanguage((lg === 'en' ? 'en-US' : (lg === 'es' ? 'es-co' : lg))).then()
            .finally(() => dispatch(onChangeLanguage((lg === 'en-US' ? 'en' : (lg === 'es-co' ? 'es' : lg)))));
    }
    const changeLanguaje = lang => {
        if (window.location.pathname !== '/' && !window.location.pathname.includes('/TerminosYCondiciones')) {
            const data = jwt_decode(localStorage.getItem('tokenMKT'));
            loginService.tokenRefresh(data.email, data.role, i18n.resolvedLanguage)
                .then(rp => {
                    localStorage.setItem('tokenMKT', rp.data.credential);
                    dispatch(onChangeLoading());
                    reloadLanguage(lang);
                })
                .finally(() => dispatch(onChangeLoading()));
        } else {
            reloadLanguage(lang);
        }
    }

    return ( 
        <div className="Language">
            <div>
                <label htmlFor="">{i18n.resolvedLanguage === "en" ? t('LANGUAGE.EN') : t('LANGUAGE.ES')}</label>
                <ul>
                    <li> 
                        <LinkComponent onClick={() => changeLanguaje((i18n.resolvedLanguage !== "en" ? 'en-US' : 'es-co'))} text={t('LANGUAGE.' + (i18n.resolvedLanguage !== "en" ? 'EN': 'ES'))} />
                    </li>
                </ul>
            </div>
        </div>
    );
}
